export default "__VITE_ASSET__8oGZFr5___"